











import Vue from 'vue'
import CloseIcon from '@/components/icons/CloseIcon.vue'
import SpellInfo from '@/components/SpellInfo.vue'

export default Vue.extend({
  name: 'SpellDetail',
  components: {
    CloseIcon,
    SpellInfo,
  },
  computed: {
    spell () {
      return this.$store.state.spells[this.$route.params.spellId]
    },
  },
})
